import { requireDefined } from '../../../utils/require-defined.util'

export class ClickedObject {
  id: string | number

  constructor(gPoint: GeoJSON.Feature) {
    this.id = requireDefined(gPoint.properties, 'the clicked feature properties').id
  }
}
